import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c73edfa6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "oxd-main-menu-item-wrapper" }
const _hoisted_2 = ["href"]
const _hoisted_3 = { style: {"display":"flex","align-items":"center","justify-content":"center","width":"24px","height":"24px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_oxd_text = _resolveComponent("oxd-text")!

  return (_openBlock(), _createElementBlock("li", _hoisted_1, [
    _createElementVNode("a", {
      class: _normalizeClass(_ctx.menuClasses),
      href: _ctx.url
    }, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.icon)
          ? (_openBlock(), _createElementBlock("i", {
              key: 0,
              class: _normalizeClass('fa-solid fa-' + _ctx.icon),
              style: 'font-size: 22px;'
            }, null, 2))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_oxd_text, {
        tag: "span",
        class: "oxd-main-menu-item--name"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.name === 'Admin' ? 'Super User' : _ctx.name), 1)
        ]),
        _: 1
      })
    ], 10, _hoisted_2)
  ]))
}